import React from "react";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import "./styles.css";
import { styled } from "@material-ui/core/styles";

const RoomOutlined = styled(RoomOutlinedIcon)({
    color: '#596E79',
    marginRight: 10,
    fontSize: 20
});

function coordinatesExcelCell(options, column, gridCell) {
  if (gridCell.value) {
    options.value = (gridCell.data[column.dataField + "_latitude"] || "")
      + "  "
      + (gridCell.data[column.dataField + "_longitude"] || "");
  }
}

function coordinatesCell(config, columnSpec) {
  let prefix = columnSpec.dataField;
  let latitudeField = prefix + "_latitude";
  let longitudeField = prefix + "_longitude";

  config.cellRender = CoordinatesCell;
  config.dataType = "string";
  config.alignment = "left";

  config.calculateCellValue = (row) => {
    if (row[longitudeField] != null) {
      return (row[longitudeField] || "") + ";" + (row[latitudeField] || "");
    } else {
      return row[latitudeField] || "";
    }
  }

  /*config.calculateCellValue = (row) => {
    if (row[prefix]) {
      return row[prefix] || "";
    } else {
      return null;
    }
  }*/
}

const CoordinatesCell = (cellData) => {
  if (cellData.value && cellData.value !== ';') {
    let coordinatesList = cellData.value.split(';');
    let longitude = coordinatesList.length >=1 ? coordinatesList[0] : '';
    let latitude = coordinatesList.length > 1 ? coordinatesList[1] : '';
    return (
      (longitude!== '' && latitude !== '') ?
        <div className="coordinates-cell">
          <RoomOutlined />
          <div>
            {longitude}
            <br />
            {latitude}
          </div>
        </div> : <></>
    );
  }
};

export {coordinatesCell, coordinatesExcelCell, CoordinatesCell};
